import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lgv-file-upload-box',
  templateUrl: './file-upload-box.component.html',
  styleUrls: ['./file-upload-box.component.scss']
})
export class FileUploadBoxComponent {
  @Input() isVisible = true;
  @Input() uploadBoxCSS: string = '';
  @Input() showInternalUserCheck = true;
  @Input() isInternalUser = false;
  @Input() customText: string = 'Drag and drop, choose file, or upload photo';

  @Output() dragOver = new EventEmitter<DragEvent>();
  @Output() dropSuccess = new EventEmitter<DragEvent>();
  @Output() dragLeave = new EventEmitter<DragEvent>();
  @Output() clickEvent = new EventEmitter<MouseEvent>();

  onDragOver(event: DragEvent): void {
    this.dragOver.emit(event);
  }

  onDropSuccess(event: DragEvent): void {
    this.dropSuccess.emit(event);
  }

  onDragLeave(event: DragEvent): void {
    this.dragLeave.emit(event);
  }

  onClickEvent(event: MouseEvent): void {
    this.clickEvent.emit(event);
  }
} 